<template>
    <div>
        <div class="loader" v-if="loading"></div>
        <div class="row">
            <b-col md="9">
                <h2 class="card-title">Page {{ pagenum() }} remaining amount of images required: {{
                    remainingCount -currentPhotoBookImages.length }}</h2>
            </b-col>
            <b-col md="3" class="text-right">
                <span class="badge badge-info badge-circle text-white" @click="showHint()">
                    <i class="fa fa-question"></i>
                </span>
            </b-col>

        </div>

        <DropFile :pbid="this.currentPhotoBook.id" @photoBookImageUploaded="photoBookImageUploaded"
            @uploading="uploading" />
    </div>

</template>

<script>
import Comment from '@/components/Feed/Comment';
import { mapGetters } from "vuex";
import { Modal, BaseAlert } from '@/components'
import swal from 'sweetalert2';
import DropFile from "../DropFile.vue";

export default {
    name: "photo-book-interior-image-uploader",
    components: {
        Modal,
        BaseAlert,
        DropFile,
    },
    props: {
        image: '',
        remainingCount: 120,


    },
    data() {
        return {
            loading: false,
            baseAmount: 120,
        };
    },
    methods: {
        showHint() {
            swal.fire({
                title: 'Interior images',
                text: 'Please use the same technical requirements as before: 300dpi jpeg.',
                icon: 'info',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-info'
            });
        },
        pagenum() {
            let number_of_pages = Number(this.baseAmount) - Number(this.remainingCount - this.currentPhotoBookImages.length);
            console.log("Number of pages");
            console.log(number_of_pages);
            console.log("basenum");
            console.log(this.baseAmount);
            return Number(this.baseAmount) - Number(this.remainingCount - this.currentPhotoBookImages.length)
        },
        uploading(state) {
            console.log(state);
            console.log("in uploader! ");
            if (state) {
                this.loading = true;
            }
            else {
                 this.loading = false;
            }

        },
        loadingSpinner(val){
            this.loading = val;
        },
        photoBookImageUploaded(data) {
            console.log("in uploader! ");
            console.log("event here --> " + data);
            console.log("data here --> " + data);
            this.$emit('photoBookImageUploaded', data);
            this.loading = false;
        },
        retrievePhotoBookImage() {
            console.log("the one image");
            console.log(this.image);
            console.log("the one image");
            return this.$image_host + "/" + this.image.image.medium.url;
            this.loading = true;
            let query = {};
            query["imgid"] = this.image.id;
            this.$api.getPhotoBookImage(this.image.imageable_id, this.image.id)
                .then((response) => {
                    this.photo_book_image = response.data;
                    console.log(this.photo_book_image);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false;
                    return 'http://0.0.0.0:8000/' + this.photo_book_image.image.medium.url;
                });
        },
    },
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
            currentPhotoBook: 'currentPhotoBook',
            currentPhotoBookImages: 'currentPhotoBookImages'
        }),
    },
    mounted() {
        console.log(this.image);
        console.log(this.currentPhotoBook.id);
    },
};
</script>